import React, { useState } from 'react';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';

const BarcodeScanner = () => {
  const [data, setData] = useState('Nincs eredmény');

  return (
    <div style={{ textAlign: 'center' }}>
      <h2>Vonalkód-olvasó</h2>
      <BarcodeScannerComponent
        width={300}
        height={300}
        onUpdate={(err, result) => {
          if (result) {
            setData(result.text);
          }
        }}
      />
      <p>Eredmény: {data}</p>
    </div>
  );
};

export default BarcodeScanner;
